
import { Component } from 'react';
import PropTypes from 'prop-types';

const canUseDOM = () => typeof window !== 'undefined';

export const ZendeskAPI = (...args) => {
  if (canUseDOM() && window.zE) {
    window.zE(...args);
  } else {
    console.warn('Zendesk is not initialized yet');
  }
  
};

export default class Zendesk extends Component {
  constructor(props) {
    super(props);
    this.insertScript = this.insertScript.bind(this);
    this.onScriptLoaded = this.onScriptLoaded.bind(this);
  }

  onScriptLoaded() {
    if (typeof this.props.onLoaded === 'function') {
      this.props.onLoaded();
    }
  }

  insertScript(zendeskKey, defer) {
    const script = document.createElement('script');
    script.id = 'ze-snippet';
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`;
    script.async = true;
    if (defer) {
      script.defer = true;
    }

    script.addEventListener('load', this.onScriptLoaded);
    document.body.appendChild(script);
  }

  componentDidMount() {
    if (canUseDOM() && !window.zE) {
      const { defer, zendeskKey, onLoaded, ...settings } = this.props;
      window.zESettings = settings;
      this.insertScript(zendeskKey, defer);
    }
  }

  componentWillUnmount() {
    if (!canUseDOM() || !window.zE) return;

    const zendeskScript = document.getElementById('ze-snippet');
    if (zendeskScript) {
      zendeskScript.remove();
    }
    delete window.zE;
    delete window.zESettings;
  }

  render() {
    return null;
  }
}

Zendesk.propTypes = {
  zendeskKey: PropTypes.string.isRequired,
  defer: PropTypes.bool,
  onLoaded: PropTypes.func,
};
